export default __webpack_public_path__ + "static/media/more-options.581c810a.svg";